import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';
import { ILog } from '../modelos/ILog';
import { get } from 'src/integracoes/servicos/api/api-pgloader';

export const listarLogs = async (machine_id: string): Promise<IRespostaFuncao<ILog[]>> => {
  return await get<IRespostaFuncao<ILog[]>>(`api/logs/machine/${machine_id}`);
};
